import CompanySelect from "features/company-select/company-select";
import useIsBelowDesktop from "components/layout/use-is-below-desktop";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { APP_CONFIG } from "config/app-config";
import { AccessNotice } from "features/auth/access-notice";
import { AccessLossReason, getAccessLossReason } from "features/auth/access-lost";

const NOTICE_TEXT_KEYS: Record<AccessLossReason, string> = {
  removed: "company_access_turned_off",
  none: "company_no_access",
};

function Welcome() {
  const { t } = useTranslation();
  const { search } = useLocation();
  const isBelowDesktop = useIsBelowDesktop();
  // The org chart is a picture with clickable spots at fixed positions: it needs a wide screen.
  const showOrgChart = APP_CONFIG.isUhbGroup && !isBelowDesktop;
  // Set when the person was sent here from a company they cannot use.
  const accessLossReason = getAccessLossReason(search);

  return (
    <>
      {accessLossReason && (
        <div className="m-4">
          <AccessNotice>{t(NOTICE_TEXT_KEYS[accessLossReason])}</AccessNotice>
        </div>
      )}
      {showOrgChart ? (
        <CompanySelect isList={false} orgChart={true} />
      ) : (
        <CompanySelect isList={true} orgChart={false} />
      )}
    </>
  );
}

export default Welcome;
